import { SQLGeneratedProcess } from "@avenueops/shared-types";
import _ from "lodash";
import moment from "moment";

interface Props {
  row: SQLGeneratedProcess;
}

export default function TimeElapsed({ row }: Props): JSX.Element {
  return <div>{_.capitalize(moment.duration(new Date().getTime() - row.created_at.getTime()).humanize())}</div>;
}
